import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { Bank, ContractAdjustmentRequest } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_CONTRACT_ADJUSTMENTS } = ServerConstants;
const {
  REQUEST_CONTRACT_ADJUSTMENT_CREATE_ID,
  REQUEST_CONTRACT_ADJUSTMENT_LIST_ID,
  REQUEST_CONTRACT_ADJUSTMENT_APPROVE_ID,
  REQUEST_CONTRACT_ADJUSTMENT_CANCEL_ID,
} = ServiceConstants;

export async function getContractAdjustments(
  bankCreditRequestId: number,
  bank: Bank
) {
  const requestId = REQUEST_CONTRACT_ADJUSTMENT_LIST_ID + bankCreditRequestId;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(API_V1_CONTRACT_ADJUSTMENTS, {
      params: { bankCreditRequestId, bank },
    });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getContractAdjustments, [bankCreditRequestId, bank], requestId);
  }
}

export async function createContractAdjustment(data: ContractAdjustmentRequest) {
  const requestId = REQUEST_CONTRACT_ADJUSTMENT_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_CONTRACT_ADJUSTMENTS, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, createContractAdjustment, [data], requestId);
  }
}

export async function approveContractAdjustment(id: number) {
  const requestId = REQUEST_CONTRACT_ADJUSTMENT_APPROVE_ID + id;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CONTRACT_ADJUSTMENTS}/${id}/approve`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, approveContractAdjustment, [id], requestId);
  }
}

export async function cancelContractAdjustment(id: number) {
  const requestId = REQUEST_CONTRACT_ADJUSTMENT_CANCEL_ID + id;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CONTRACT_ADJUSTMENTS}/${id}/cancel`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, cancelContractAdjustment, [id], requestId);
  }
}
